export default __webpack_public_path__ + "static/media/desconto50Mobile.fc3907a2.png";